import React, { Component } from 'react';
import ReactTable from "react-table-6"
import "react-table-6/react-table.css";
import $ from 'jquery';
import { ToastContainer, toast } from "react-toastify";
import { DialogComponent } from '@syncfusion/ej2-react-popups';
import JSONPretty from 'react-json-pretty';
import { CopyToClipboard } from 'react-copy-to-clipboard';


class Widget extends Component {
  constructor() {
    super();
    this.dialogClose = () => {
      this.setState({
        hideupdateDialog: false,
        hideAddDialog: false, hideDeletePopup: false,
      });
    };

    this.codeSnippetClose = () => {
      this.setState({
        disabled: false,
        hideGeneratePopup: false
      });
    };


    this.settings = { effect: 'Zoom', duration: 400, delay: 0 };
    //for update dialog component ok click
    this.Okbutton = [{
      buttonModel: {
        content: 'OK',
        cssClass: 'e-flat',
        isPrimary: true,
      },
      'click': () => {
        this.fetchWidgetDataAPi()
        this.dialogClose();
      }
    }];
    this.addedButton = [{
      buttonModel: {
        content: 'OK',
        cssClass: 'e-flat',
        isPrimary: true,
      },
      'click': () => {
        this.fetchWidgetDataAPi()
        this.dialogClose();
        this.setState({
          disabled: false
        })
      }
    }];

    //for delete dialog component ok click
    this.buttons = [{
      buttonModel: {
        content: 'Yes',
        cssClass: 'e-flat',
        isPrimary: true,
      },
      'click': props => {
        this.deleteWidgetApi(this.state.propsId)
        this.setState({ disabled: false })
      }
    },
    {
      buttonModel: {
        content: 'No',
        cssClass: 'e-flat',
        isPrimary: true,
      },
      'click': () => {
        this.setState({
          hideDeletePopup: false,
          disabled: false
        });
      }
    }];

    //------------------------------------------------------------------------------------------
    // for delete success
    this.deleteSuccessbuttons = [{
      buttonModel: {
        content: 'Ok',
        cssClass: 'e-flat',
        isPrimary: true,
      },
      'click': props => {
        this.dialogInstance.hide();
        this.fetchWidgetDataAPi()
        this.setState({ disabled: false })
      }
    }];


    this.state = {
      data: [{
        id: '',
        clientAppId: '',
        clientAppSecret: '',
        domain: '',
        deleteRow: false,
      }],
      utData: "",
      disabled: false,
      editedId: '-1',
      editImageSrc: './assets/images/edit.svg',
      contentEditable: "false",
      showStore: false,
      hidden: false,
      hideAddDialog: false,
      hideupdateDialog: false,
      hideDeletePopup: false,
      hideDeleteSuccessPopup: false,
      hideGeneratePopup: false,
      showCreateProjectPage: false,
      pageNum: null,

    }


    this.saveImageSrc = "./assets/images/baseline_save_white_24dp.png";
    this.editImageSrc = "./assets/images/edit2.png";
    this.valueTypeVar = [];

    //for hideGeneratePopup dialog component ok click
    this.CodeSnippetButtons = [
      {
        buttonModel: {
          content: 'Copy',
          cssClass: 'e-flat',
          isPrimary: false,
          color: 'blue'

        },
        'click': () => {
          this.copyContent();
        }
      },
      {
        buttonModel: {
          content: 'Ok',
          cssClass: 'e-flat',
          isPrimary: true,
          color: 'blue'

        },
        'click': () => {
          this.setState({
            disabled: false,
            hideGeneratePopup: false
          });
        }
      },
    ];

  }

  addRow = (data) => {

    var widgetController = this;
    if (widgetController.state.pageNum != 0) {
      widgetController.setState({ pageNum: 0 })
    }
    this.state.data.unshift({
      id: '',
      clientAppId: '',
      clientAppSecret: '',
      domain: '',
    });
    this.setState({
      data: this.state.data,
      disabled: true,

    })

  }

  copyContent = () => {
    $('#copyToClipBoard').click();
  }
  saveWidgetApi(props, e) {
    props.original.clientAppId = document.getElementById("clientAppId" + props.index).innerText.trim();
    props.original.domain = document.getElementById("domain" + props.index).innerText.trim();
    this.state.editedId = "-1";
    this.setState(this.state);
    var validateResult = this.validateCells(props.original.clientAppId) && this.validateUrlCell(props.original.domain);

    if (validateResult == true) {
      var addedData = {
        clientAppId: props.original.clientAppId,
        domain: props.original.domain,
        projectId: localStorage.getItem("currentProjectId"),
      };
      var addWidgetController = this
      $.ajax({
        url: "/api/api-credentials",
        async: false,
        method: 'POST',
        headers: {
          'Authorization': "Bearer " + localStorage.getItem("access_token"),
          'Content-Type': 'application/json',
        },
        data: JSON.stringify(addedData),
        processData: false,
        contentType: "application/json; charset=UTF-8",
        success: function (res) {
          if (res.success === true) {
            addWidgetController.notifyAdded();
            addWidgetController.fetchWidgetDataAPi();
            addWidgetController.setState({ disabled: false })
          } else {
            addWidgetController.notifyFailedResponse(res.result);
          }
        },
        error: function (xhr) {
          var errorMessage = xhr.status + ': ' + xhr.statusText
          if (xhr.status == 401) {
            window.location.href = "/platform/";
          }
        }

      })
    }
  }
  updateWidgetAPi(props, e) {

    props.original.clientAppId = document.getElementById("clientAppId" + props.index).innerText.trim();

    props.original.domain = document.getElementById("domain" + props.index).innerText.trim();

    var validateResult = this.validateCells(props.original.clientAppId) && this.validateUrlCell(props.original.domain);

    if (validateResult == true) {
      var addedData = {
        clientAppId: props.original.clientAppId,

        domain: props.original.domain,

      };
      var updatedData = {
        clientAppId: this.state.data[props.index].clientAppId,

        domain: this.state.data[props.index].domain,
        id: this.state.data[props.index].id,
        projectId: localStorage.getItem("currentProjectId"),

      };
      var updatedDataController = this
      $.ajax({
        url: "/api/api-credentials",
        async: false,
        method: 'PATCH',
        headers: {
          'Authorization': "Bearer " + localStorage.getItem("access_token"),
          'Content-Type': 'application/json',

        },
        data: JSON.stringify(updatedData),
        processData: false,
        contentType: "application/json; charset=UTF-8",
        success: function (res) {
          if (res.success === true) {
            updatedDataController.state.editedId = "-1";
            updatedDataController.notifyUpdate();
            updatedDataController.fetchWidgetDataAPi();
          } else {

            // alert("Same tag available for the project,please change the Tag.")
            updatedDataController.notifyFailedResponse(res.result);
          }
        },
        error: function (xhr) {
          var errorMessage = xhr.status + ': ' + xhr.statusText
          if (xhr.status == 401) {
            window.location.href = "/platform/";
          }
        }
      })
    }
  }

  makeCelledit(props, e) {
    this.markAsBeingEdited(this.state.data[props.index].id);
  }

  markAsBeingEdited(id) {

    this.state.editedId = id;
    var stateObj = this.state;
    this.setState(stateObj);
  }


  deleteWidgetApi = (id) => {
    let deleteRowViewController = this.state.data;
    let deleteApiViewController = this;
    var deleteConstructorVariables = this;

    if (id == "") {
      deleteApiViewController.setState({ deleteRow: true });
      deleteConstructorVariables.setState({ hideDeletePopup: false });
      deleteConstructorVariables.setState({ hideDeleteSuccessPopup: true });

    } else {
      $.ajax({
        url: "/api/api-credentials/" + id,
        async: false,
        method: 'DELETE',
        headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
        success: function (res) {

          if (res.success === true) {
            deleteApiViewController.setState({ deleteRow: true });
            deleteConstructorVariables.setState({ hideDeletePopup: false });
            deleteConstructorVariables.notifyDelete();


          } else {
            deleteRowViewController.notifyError();
          }
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "/platform/";
          }
        }

      });
    }
    if (this.state.deleteRow) {
      this.state.data.splice(id, 1);
    }
    deleteConstructorVariables.fetchWidgetDataAPi();


  }

  fetchProjectDetailsApi = (projectId) => {
    if (!projectId) {
      projectId = this.projectId;
      if (!projectId) {
        projectId = localStorage.getItem('currentProjectId');
      }
    }
    var voiceController = this;
    $.ajax({
      url: "/api/project-details",
      async: false,
      method: 'GET',
      data: {
        "projectId": projectId
      },
      headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
      success: function (res) {
        if (res.success === true) {
          if (res.result.deployed == false) {
            voiceController.notifyNotAdded("Oops!you have not deployed your project")
            var voiceInterval = setInterval(function () {
              clearTimeout(voiceInterval);
              window.location.href = '/platform/projectmgmt/test-and-deploy/DistributionWidget';
            }, 3000);
          }
        } else {
          voiceController.notifyNotAdded("Oops!you have not deployed your project")
          var voiceInterval = setInterval(function () {
            clearTimeout(voiceInterval);
            window.location.href = '/platform/projectmgmt/test-and-deploy/DistributionWidget';
          }, 3000);
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/";
        }
      }
    });
  }


  notifyNotAdded(message) {
    toast.dismiss();
    toast(<b><img src="assets/images/warn.svg"
      style={{ paddingRight: '0px', height: '20px', width: '20px' }}
      content="" />&nbsp;&nbsp;{message}</b>, {
      position: "top-center"
    });
  }


  componentDidMount() {
    setTimeout(() => {
      this.fetchProjectDetailsApi();
      this.fetchWidgetDataAPi();
    }, 300);
    var thisController = this;
    document.addEventListener("projectChanged", function (event) {
      thisController.projectId = event.projectId;
      thisController.fetchProjectDetailsApi(event.projectId);
      thisController.fetchWidgetDataAPi(event.projectId);
    });
  }
  validateCells(clientAppId) {
    if ((clientAppId == "")) {
      this.notifyEmptyFields();
      return false;
    }
    else {
      return true;
    }

  }
  validateCells(clientAppSecret) {
    if ((clientAppSecret == "")) {
      this.notifyEmptyFields();
      return false;
    }
    else {
      return true;
    }
  }

  validateUrlCell(url) {
    var pattern = new RegExp(/^((https|http):\/\/)/);
    if (!pattern.test(url)) {
      this.notifyInvalidUrlFiled();
      return false;
    }
    else {
      return true;
    }
  }


  notifyInvalidUrlFiled() {
    toast(<b
    >Please give a valid Domain Url</b>, {
      position: "bottom-center",
      color: "#007aff"

    });
  }

  refreshData = (id) => {
    var refreshContent = this
    refreshContent = this.state.editedId = id;
    this.fetchWidgetDataAPi()
    this.setState({ disabled: false })

  }
  fetchWidgetDataAPi = (projectId) => {
    if (!projectId) {
      projectId = this.projectId;
      if (!projectId) {
        projectId = localStorage.getItem('currentProjectId');
      }
    }
    var widgetLoadController = this;
    $.ajax({
      url: "/api/api-credentials",
      async: false,
      method: 'GET',
      data: { projectId: projectId },
      headers: {
        "Authorization": "Bearer " + localStorage.getItem("access_token"),
        "Content-Type": "application/json",
      },
      success: function (res) {
        if (res.success === true) {
          var clientAppIds = res.result;
          widgetLoadController.state.disabled = false;
          widgetLoadController.state.data = clientAppIds;
          widgetLoadController.setState(widgetLoadController.state);
        } else {
          widgetLoadController.notifyFailedResponse();
        }
      }
    });
  }

  handleChange = (e) => {
    this.setState({ selectValue: e.target.value });
  }

  generateDemoCodeSnippetAPi = (id) => {
    var DemoCodeSnippetController = this;
    $.ajax({
      url: "/api/api-credentials/generate",
      async: false,
      method: 'GET',
      data: {
        credentialId: id
      },
      headers: {
        "Authorization": "Bearer " + localStorage.getItem("access_token"),
        "Content-Type": "application/json",
      },
      success: function (res) {
        if (res.success === true) {
          var clientAppIds = res.result;
          DemoCodeSnippetController.setState({ utData: res.result })

        } else {
          DemoCodeSnippetController.notifyFailedResponse();
        }
      }
    });
  }
  notifyFailedResponse(response) {
    toast.dismiss();
    toast(<b style={{ color: "red" }}>{response}</b>, {
      position: "top-center",
      color: "red"

    });
  }

  notifyDataAlreadyAdded = () => {
    toast.dismiss();
    toast(<b>Client app id is already created</b>, {
      position: "bottom-center",
      color: "#007aff"
    });
  }

  notifyAdded() {
    toast.dismiss();
    toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;Added Successfully</b>, {
      position: "top-center",
    });
  }

  notifyError() {
    toast.dismiss();
    toast(<b
      style={{ color: "red" }} ><img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
        content="" />&nbsp;&nbsp;Oops! Error occurred.Please try again</b>, {
      position: "top-center"
    });
  }

  notifyUpdate() {
    toast.dismiss();
    toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;Updated Successfully</b>, {
      position: "top-center",
    });
  }

  notifyDelete() {
    toast.dismiss();
    toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;Deleted Successfully</b>, {
      position: "top-center",
    });
  }
  notifyEmptyFields() {
    toast.dismiss();
    toast(<b>Please fill all fields</b>, {
      position: "bottom-center",
      color: "#007aff"
    });
  }


  notifyEmptyFieldForAdd() {
    toast.dismiss();
    toast(<b>Please fill all the data</b>, {
      position: "top-center"
    });
  }
  onPageChange = (e) => {
    this.setState({ pageNum: e })
  }

  render() {
    const { data } = this.state
    const columns = [
      {
        Header: 'Id',
        accessor: 'id',
        show: false,
        Cell: props => (
          <div name="id" id={"id" + props.index}>{props.original.id}</div>)
      },
      {
        Header: () =>
          <div><b>APP ID</b>&nbsp;&nbsp;
            <button style={{ border: 'none', background: '#ffffff' }}
              aria-label="APP ID is Unique name, which recognises your widget. eg: my_dhee_widget"
              className="tooltip-red" data-balloon-pos="down-left">
              <i style={{ color: "#282a65", fontSize: '17px' }}
                // title="APP ID is Unique name, which recognises your widget. eg: my_dhee_widget"
                class="fa fa-question-circle">
              </i>
            </button>
          </div >,
        accessor: 'clientAppId',
        sortable: false,
        flexGrow: 1,
        // width: 200,
        Cell: props => (
          <div name="clientAppId">
            <div className="textarea" type="text"
              style={{ background: 'white', height: "2.7em", resize: 'none', width: '98%', paddingLeft: '2px', paddingTop: '6px', border: (props.original.id == "" || props.original.id == this.state.editedId) ? '1px solid #D2D4DC' : 'none', borderRadius: (props.original.id == "") ? '2px' : 'none' }}
              id={"clientAppId" + props.index}
              rows="1"
              maxlength="250"
              contentEditable={!((props.original.id == "" ) ? false :
                props.original.id != this.state.editedId) ? "plaintext-only" : false}
              >{props.original.clientAppId}
            </div>
          </div>)
      },
      {
        Header: () => <b>Domain</b>,
        accessor: 'domain',
        sortable: false,
        Cell: props => (
          <div name="domain">
            <div className="textarea" type="text"
              style={{ background: 'white', height: "2.7em", resize: 'none', width: '98%', paddingLeft: '2px', paddingTop: '6px', border: (props.original.id == "" || props.original.id == this.state.editedId) ? '1px solid #D2D4DC' : 'none', borderRadius: (props.original.id == "") ? '2px' : 'none' }}
              id={"domain" + props.index}
              rows="1"
              maxlength="250"
              contentEditable={!((props.original.id == "") ? false :
                props.original.id != this.state.editedId) ? "plaintext-only" : false}
              >{props.original.domain}
            </div>
          </div>)
      },
      {
        Header: <b>Action</b>,
        accessor: 'action',
        sortable: false,
        width: 200,
        Cell: props => (
          <div id="action">
            <button className="btn2 table-action-button "
              hidden={(props.original.id == "") ? true : false}
              title="Generate"
              onClick={() => {
                this.generateDemoCodeSnippetAPi(props.original.id)
                this.setState({
                  hideGeneratePopup: true,
                  propsId: props.original.id,

                })
              }} >Generate</button>

            <button style={{ backgroundColor: "#ffffff", border: "none", marginTop: '-9px', marginLeft: '2px' }} >
              <img className="img-responsive"
                title={(props.original.id == "") ||
                  (this.state.data[props.index].id == this.state.editedId) ? 'Save' : 'Edit'}
                style={{ marginTop: '6px', backgroundColor: '#282a65', borderRadius: '5px', padding: '1px' }}
                src={(props.original.id == "") ? this.saveImageSrc : ((props.original.id != this.state.editedId) ? this.editImageSrc : this.saveImageSrc)}
                onClick={(e) => {
                  (props.original.id == "") ? this.saveWidgetApi(props, e) : (props.original.id == this.state.editedId) ?
                    this.updateWidgetAPi(props, e) : this.makeCelledit(props, e);
                }} />
            </button>

            <button style={{
              backgroundColor: "#ffffff", border: "none", marginTop: '-9px', marginLeft: '-6px'
            }} title="Delete">
              <img className="img-responsive" src={"./assets/images/baseline_delete_white_24dp.png"}
                style={{
                  marginTop: '6px', backgroundColor: '#282a65', borderRadius: '5px', padding: '1px'
                }}
                onClick={() => (props.original.id) === '' ?
                  this.fetchWidgetDataAPi() :
                  this.setState({
                    hideDeletePopup: true, deletePropIndex: props.index,
                    propsId: props.original.id
                  })}
              /></button>
          </div>
        ),

      },
    ]

    return (
      <div style={{ background: "#F9F9FB", marginRight: '1%' }}>
        {/* for toaster */}
        <link rel="stylesheet" href="assets/css/ReactToastify.css" />
        {/* for reactTable */}
        <link rel="stylesheet" href="assets/css/React_Table_CSS/react-table.css" />
        {/*for dialog component */}
        <link href="assets/css/ej2-base.css" rel="stylesheet" />
        <link href="assets/css/ej2-react-buttons.css" rel="stylesheet" />
        <link href="assets/css/ej2-react-popups.css" rel="stylesheet" />
        <link href="assets/css/ej2-inputs.css" rel="stylesheet" />
        <link href="assets/css/screenResolution.css" rel="stylesheet" />
        <div className="wrapper">
          <link rel="shortcut icon" type="image/png" href="assets/images/bot.ico" />
          <title> Dheeyantra | Widget </title>
          {/* For ToolTip */}
          <link rel="stylesheet" href="assets/css/tooltip.css" />
          {/* Font Awesome Icons */}
          <link rel="stylesheet" href="plugins/font-awesome/css/font-awesome.min.css" />
          {/* IonIcons */}
          <link rel="stylesheet" href="//code.ionicframework.com/ionicons/2.0.1/css/ionicons.min.css" />
          <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
          {/* Theme style */}
          <link rel="stylesheet" href="assets/css/adminlte.css" />
          <link href="https://cdn.jsdelivr.net/npm/gijgo@1.9.6/css/gijgo.min.css" rel="stylesheet" />
          <link rel="stylesheet" href="plugins/select2/select2.min.css" />
          <link rel="stylesheet" href="assets/css/custom-style.css" />
          <link rel="stylesheet" href="assets/css/styles.css" />
          {/* Content Wrapper. Contains page content */}

          <div className="content-header">
            <div className="row" style={{ marginLeft: '3px', marginTop: '-35px' }}>
              <div className="col-sm-5">
                <h6 className="nav-item" style={{ color: '#282a65', marginTop: '40px' }}>Widget Credentials Data</h6>
              </div>
              {/* Add button */}
              <div className="col-sm-7 p-0">
                <div className="d-flex flex-row-reverse pt-2">
                  <div className="p-2">
                    <button className="btn action-button"
                      id="addMsg" title=" Add "
                      onClick={this.state.disabled ? this.notifyEmptyFieldForAdd : this.addRow}>
                      <img src="assets/images/add_white_24dp.png" />
                    </button>


                    <button title="Refresh" onClick={this.refreshData} type="button" className="btn action-button">
                      <img src="./assets/images/refresh_white_24dp.png"></img></button>
                  </div>
                </div>
              </div>
            </div>

          </div>
          <div className="content">
            <div className="container-fluid">
              <div className="row">
                <div className="col-lg-12 ">
                  <div className="card" style={{ marginLeft: '10px', marginTop: '-10px' }}>
                    <ReactTable
                      data={data}
                      columns={columns}
                      defaultPageSize={10}
                      pageSizeOptions={[5, 10, 15]}
                      onPageChange={this.onPageChange}
                      page={this.state.pageNum}
                    />
                  </div>
                  <ToastContainer className="Toast-at-center" />
                  <div>
                    <CopyToClipboard id="copyToClipBoard" text={this.state.utData}>
                      <button className="btn action-button" style={{ marginBottom: "10px", display: 'none' }}></button>
                    </CopyToClipboard>
                  </div>
                  {/*Dialog Component For Deletion Confirmation*/}
                  <DialogComponent width='400px' animationSettings={this.settings}
                    header='Delete Confirmation' showCloseIcon={true} buttons={this.buttons}
                    ref={dialog => this.dialogInstance = dialog}
                    visible={this.state.hideDeletePopup} close={this.dialogClose}>
                    <img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
                      content="" />&nbsp;Do you want to delete the Widget Credentials?
                    &nbsp;Note: Press 'Yes' to delete or press 'No' to decline.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</DialogComponent>

                  {/*Dialog Component For CodeSnippet*/}
                  <DialogComponent width='500px' height="300px" style={{ verticalAlign: 'top' }} animationSettings={this.settings}
                    header='CodeSnippet' showCloseIcon={true} buttons={this.CodeSnippetButtons}
                    ref={dialog => this.dialogInstance = dialog}
                    visible={this.state.hideGeneratePopup} close={this.codeSnippetClose}>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <JSONPretty id="json-pretty" data={this.state.utData} title={this.state.utData}
                      style={{ fontSize: '18px' }}></JSONPretty>
                  </DialogComponent>


                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
export default Widget



// WEBPACK FOOTER //
// ./src/projectmgmt/testAndDeploy/Widget.js